/*
 * reflections-pending-badge
 */
import { useTranslation } from "react-i18next"
import { trpc } from "../../trpc"
import { FeatureBadge } from "./feature-badge"

export function ReflectionsPendingBadge() {
	const { t } = useTranslation()
	const { data } = trpc.reflectionQuestion.getPendingCount.useQuery()

	if (!data?.count || data.count < 0) {
		return null
	}

	return (
		<FeatureBadge
			label={t("features.reflections.badgePending", { count: data.count })}
			variant="secondary"
		>
			{data.count}
		</FeatureBadge>
	)
}
